import { request } from '../../../gateways/api'
import type { Klantgegevens } from '../types/Klantgegevens'

export { fetchKlantgegevens }

const fetchKlantgegevens = async ({
  id,
}: {
  id: string
}): Promise<Klantgegevens> => {
  const result = await request({
    url: `/rest/project/${id}/klant`,
    method: 'GET',
  })

  return result
}
